import { API, Endpoints } from '@brg/api';

export function fetchCardGetListShowcase(
  page: number,
  limit: number,
  tagIds: string[],
  sendOpts?: { signal?: AbortSignal }
) {
  return API.request()
    .endpoint(Endpoints.cardsMnePw)
    .url('/api/Card/GetList')
    .get()
    .addQuery('page', page)
    .addQuery('limit', limit)
    .addQuery('cardOnlyImage', 'true')
    .addQuery('exceptContexts', '365')
    .addQuery('filter', 2)
    .addQuery('includeTags', 'true')
    .addQuery('includeTemplates', 'true')
    .addQuery('isHeaderIgnored', 'true')
    .addQuery('isLite', 'true')
    .addQuery('isProduct', 'false')
    .addQuery('search', '')
    .addQuery('status', 2)
    .addQuery('categoryCard', 0)
    .addQuery('tagIds', tagIds)
    .send(sendOpts?.signal ? { signal: sendOpts.signal } : {})
    .then((r) => r.json());
}
import { API, Endpoints } from '@brg/api';

export function fetchCardGetListShowcase(
  page: number,
  limit: number,
  tagIds: string[],
  sendOpts?: { signal?: AbortSignal }
) {
  return API.request()
    .endpoint(Endpoints.cardsMnePw)
    .url('/api/Card/GetList')
    .get()
    .addQuery('page', page)
    .addQuery('limit', limit)
    .addQuery('cardOnlyImage', 'true')
    .addQuery('exceptContexts', '365')
    .addQuery('filter', 2)
    .addQuery('includeTags', 'true')
    .addQuery('includeTemplates', 'true')
    .addQuery('isHeaderIgnored', 'true')
    .addQuery('isLite', 'true')
    .addQuery('isProduct', 'false')
    .addQuery('search', '')
    .addQuery('status', 2)
    .addQuery('categoryCard', 0)
    .addQuery('tagIds', tagIds)
    .send(sendOpts?.signal ? { signal: sendOpts.signal } : {})
    .then((r) => r.json());
}
